import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { accountsPayableAPI } from 'services/apiRest';
import AccountsPayableActions from '../ducks/accountsPayable';

export function* getAccountsPayable() {
  try {
    const accounts = yield call(accountsPayableAPI.listar);
    yield put(AccountsPayableActions.getAccountsPayableSuccess(accounts));
  } catch (err) {
    console.error('Erro ao buscar contas a pagar:', err);
    yield put(AccountsPayableActions.getAccountsPayableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar contas a pagar',
      })
    );
  }
}

export function* addAccountPayable({ account, closeModal }) {
  try {
    const accountCriada = yield call(accountsPayableAPI.criar, account);
    yield put(AccountsPayableActions.addAccountPayableSuccess(accountCriada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Pagar',
        message: 'Conta criada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar conta a pagar:', err);
    yield put(AccountsPayableActions.addAccountPayableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar conta a pagar',
      })
    );
  }
}

export function* updateAccountPayable({ account, closeModal }) {
  try {
    const accountAtualizada = yield call(
      accountsPayableAPI.atualizar,
      account.id,
      account
    );
    yield put(AccountsPayableActions.updateAccountPayableSuccess(accountAtualizada));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Pagar',
        message: 'Conta atualizada com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar conta a pagar:', err);
    yield put(AccountsPayableActions.updateAccountPayableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar conta a pagar',
      })
    );
  }
}

export function* removeAccountPayable({ id }) {
  try {
    yield call(accountsPayableAPI.deletar, id);
    yield put(AccountsPayableActions.removeAccountPayableSuccess(id));
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Conta a Pagar',
        message: 'Conta excluída com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir conta a pagar:', err);
    yield put(AccountsPayableActions.removeAccountPayableFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir conta a pagar',
      })
    );
  }
}

